<template>
    <div>
        <b-card >
          <b-row><b-col><b>Commission Date</b></b-col>
          <b-col><b-form-datepicker
            id="commission_date"
            v-model="commissionDetails.CommissionDate"
            today-button    
            locale="en"
            ></b-form-datepicker></b-col></b-row>
          <b-row><b-col><b>Commission Time</b></b-col>
          <b-col> <b-form-timepicker
            id="commission_time"
            v-model="commissionDetails.CommissionTime"
            now-button
            locale="en"
            ></b-form-timepicker></b-col></b-row>
        </b-card>
        <b-card v-if="this.Type == 'C1'" align-content="center">
          <h3>Device ID: {{this.ID}}</h3>
        <b-row><b-col><b>Department / Area</b></b-col><b-col><b-form-input type="text" v-model="commissionDetails.DeptFloor" placeholder="Department/Area of install"></b-form-input></b-col></b-row>
        <b-row><b-col><b>Location Note</b></b-col><b-col><b-form-input type="text" v-model="commissionDetails.LocationNote" placeholder="Additional note on location"></b-form-input></b-col></b-row>
        <b-row><b-col><b>No of Probes</b></b-col><b-col><b-form-select v-model="ProbeNo" :options="C1ProbeOptions" size="sm"></b-form-select></b-col></b-row>
        <hr/>
        <b-card-group deck >
        <b-card class="TwoWideRepeatDash" v-for="(id,idx) in this.ProbeArray" :key="idx"
                    header-border-variant="info"
                    header-bg-variant="info"
                    header-text-variant="light">
                    <template #header>
                <b-row><b-col>Probe {{ id.ProbeNo }}</b-col></b-row></template>
           <hr/>
        <b-row><b-col><b>Probe Feed</b></b-col><b-col><b-form-select v-model="id.ProbeFeed" :options="FeedArray"></b-form-select></b-col></b-row>
        <b-row><b-col><b>Probe Position</b></b-col><b-col><b-form-select v-model="id.ProbePosition" :options="PositionArray"></b-form-select></b-col></b-row>
        <b-row><b-col><b>Probe Recirculatory</b></b-col>
          <b-col><b-form-select v-model="id.ProbeRecirc" :options="RecircOptions"></b-form-select></b-col></b-row>
             </b-card>
        </b-card-group>
         <br/>
        </b-card>
        <b-card v-if="this.Type == 'O1'" align-content="center">
          <h3>Device ID: {{this.ID}}</h3>
        <b-row><b-col><b>Department / Area</b></b-col><b-col><b-form-input type="text" v-model="commissionDetails.DeptFloor" placeholder="Department/Area of install"></b-form-input></b-col></b-row>
        <b-row><b-col><b>Location Note</b></b-col><b-col><b-form-input type="text" v-model="commissionDetails.LocationNote" placeholder="Additional note on location"></b-form-input></b-col></b-row>
        <b-row><b-col><b>No of Probes</b></b-col><b-col><b-form-select v-model="ProbeNo" :options="O1ProbeOptions" size="sm"></b-form-select></b-col></b-row>
        <hr/>
          <b-card-group deck >
         <b-card class="TwoWideRepeatDash" v-for="(id,idx) in this.ProbeArray" :key="idx"
                  header-border-variant="info"
                  header-bg-variant="info"
                  header-text-variant="light">
                    <template #header>
                <b-row><b-col>Probe {{ id.ProbeNo }}</b-col></b-row></template>
          <hr/>
        <b-row><b-col><b>Probe Feed</b></b-col><b-col><b-form-select v-model="id.ProbeFeed" :options="FeedArray"></b-form-select></b-col></b-row>
        <b-row><b-col><b>Probe Position</b></b-col><b-col><b-form-select v-model="id.ProbePosition" :options="PositionArray"></b-form-select></b-col></b-row>
        <b-row><b-col><b>Probe Recirculatory</b></b-col>
         <b-col><b-form-select v-model="id.ProbeRecirc" :options="RecircOptions"></b-form-select></b-col></b-row>
        </b-card>     
        </b-card-group>
          <br/>
        </b-card>
        <b-card v-if="this.Type == 'Router'">
          <h3>Router ID: {{ this.ID }}</h3>
          <b-row><b-col><b>Department / Area</b></b-col><b-col><b-form-input type="text" v-model="commissionDetails.DeptFloor" placeholder="Department/Area of install"></b-form-input></b-col></b-row>
          <b-row><b-col><b>Location Note</b></b-col><b-col><b-form-input type="text" v-model="commissionDetails.LocationNote" placeholder="Additional note on location"></b-form-input></b-col></b-row>
        
          <br/>
        </b-card>
        <b-row><b-col><b-button variant="outline-success" v-if="stepComplete == false" v-on:click="CompletePage()">Page Complete</b-button></b-col></b-row>
         
    </div>
</template>

<script>

    export default {
      props:['DataPass','Type','ID','Feeds','Positions'],
      data() {
      return {
        stepComplete: false,
        commissionDetails: {
          CommissionTime:"",
          CommissionDate:"",
          DeptFloor: "",
          LocationNote: "",
        },
        Values:[],
        C1ProbeOptions:[{value: null, text:'Select number of probes to commission'},{value:1,text:'One Probe'},{value:2,text:'Two Probe'}],
        O1ProbeOptions:[{value: null, text:'Select number of probes to commission'},{value:1,text:'One Probe'},{value:2,text:'Two Probe'},{value:3,text:'Three Probe'},{value:4,text:'Four Probe'}],
        RecircOptions: [{value: null, text: 'Please select an option' },{ value: 'TRUE', text: 'True' },
          { value: 'FALSE', text: 'False' }],
        ProbeArray:[],
        showProbeDetail: false,
        FeedArray: [],
        PositionArray: [],
        ProbeNo: null,
      }
    },
    computed: {},
    components: {},
    watch: {
      ProbeNo() {
      this.setProbeArray();
    },
    },
    methods:{
      CompletePage(){
        let valid = ""
        if(this.commissionDetails.CommissionDate == "" || this.commissionDetails.CommissionTime == ""){
          alert('Date and Time fields must be completed prior to moving on')
          valid = "false"
        }
        if(this.Type != 'Router'){
          if(this.commissionDetails.DeptFloor == "" || this.ProbeNo == null){
            alert('You need to complete Area of install and select number of probes')
            valid = "false"
          }
          for (let i = 0; i<this.ProbeArray.length;i++){
            if(this.ProbeArray[i].ProbeFeed == ""|| this.ProbeArray[i].ProbePosition == ""|| this.ProbeArray[i].ProbeRecirc == ""){
              alert("Please complete all fields for all probes")
              valid = "false"
          }
        }
      }

        if (valid != "false"){
          this.Values.push(this.Type)
          this.Values.push(this.commissionDetails)
          this.Values.push(this.ProbeNo)
          this.Values.push(this.ProbeArray)
          this.$emit("PageComplete",2,this.Values);
          this.stepComplete = true;
        }
        

        
      },
      setProbeArray(){
        this.showProbeDetail = false;
        this.ProbeArray = []
        for (let x=0; x < this.ProbeNo; x++){
          this.ProbeArray.push(
            {
              ProbeNo: x+1,
              ProbeFeed: "",
              ProbePosition:"",
              ProbeRecirc:"",
              ProbeTag:"",
              ProbeTemp: "",
              ProbeFlow: ""
            }
          )

        }
        this.showProbeDetail = true;
      }
    },
    mounted(){
      for (let x = 0; x < this.Feeds.length; x++){
        this.FeedArray.push(this.Feeds[x].text)
      }
      for (let y = 0; y < this.Positions.length; y++){
        this.PositionArray.push(this.Positions[y].text)
      }

    }

    }
</script>

<style>
.TwoWideRepeatDash{
  min-width: 45%; max-width: 100%; margin-bottom: 1rem !important;
}

</style>